// extracted by mini-css-extract-plugin
module.exports = {"logoRows":"logo-rows_logoRows__OdWws","logoImage":"logo-rows_logoImage__hIeTR","logoImageSvg":"logo-rows_logoImageSvg__URuqg"};